import styled from 'styled-components';

import { nepal } from '@paradigm/design-system/src/colors';

import Select, { Props } from '@paradigm/design-system/src/components/Select';
import { OptionTypeBase } from '@paradigm/design-system/src/components/Select/types';

export default function SelectField<OptionType extends OptionTypeBase>({
  id,
  label,
  ...props
}: Props<OptionType>) {
  return (
    <div>
      <div css="display: flex;">
        {label != null && <Label htmlFor={id}>{label}</Label>}
      </div>

      <SelectContainer>
        <Select id={id} {...props} />
      </SelectContainer>
    </div>
  );
}

const Label = styled.label`
  color: ${nepal};
  margin-bottom: 0.1rem;
  flex: 1;
`;

export const SelectContainer = styled.div`
  margin-bottom: 1rem;
`;
